module.exports = __webpack_public_path__ + "img/icon-resume-12012022.c5f52d5f.svg";